'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.capitalize = exports.isSpecialClick = exports.createClassNames = undefined;

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createClassNames = exports.createClassNames = function createClassNames(block) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ais';
  return function () {
    for (var _len = arguments.length, elements = Array(_len), _key = 0; _key < _len; _key++) {
      elements[_key] = arguments[_key];
    }

    var suitElements = elements.filter(function (element) {
      return element || element === '';
    }).map(function (element) {
      var baseClassName = prefix + '-' + block;

      return element ? baseClassName + '-' + element : baseClassName;
    });

    return (0, _classnames2.default)(suitElements);
  };
};

var isSpecialClick = exports.isSpecialClick = function isSpecialClick(event) {
  var isMiddleClick = event.button === 1;
  return Boolean(isMiddleClick || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey);
};

var capitalize = exports.capitalize = function capitalize(key) {
  return key.length === 0 ? '' : '' + key[0].toUpperCase() + key.slice(1);
};


//////////////////
// WEBPACK FOOTER
// ./~/react-instantsearch-dom/dist/cjs/core/utils.js
// module id = 11
// module chunks = 142807904292071